<template>
  <div class="title-settings">
    <!--    <el-drawer-->
    <!--      :title="$t('message.tableTitleCommon.visibleColumns')"-->
    <!--      :visible.sync="drawerDisplay"-->
    <!--      :before-close="handleClose"-->
    <!--      :size="'320px'"-->
    <!--      @open="onOpen()"-->
    <!--      :direction="'rtl'">-->
    <el-popover
      placement="bottom"
      :title="$t('message.tableTitleCommon.visibleColumns')"
      width="296"
      :visible-arrow="false"
      trigger="click"
      :offset="-100"
      @show="handleOpen"
      @hide="drawerDisplay = false;">
      <i slot="reference"
         :class="{'iconfont icon-a-TableSettings': true }" class=" "></i>
      <div id="title-settings">
        <transition-group name="drag" class="list" tag="ul">
          <li
            @dragenter="dragenter($event, index)"
            @dragover="dragover($event, index)"
            @dragstart="dragstart(index)"
            draggable
            v-for="(item, index) in titleSettingsList"
            :key="item.label"
            class="list-item">
            <div class="title-wrap">
              <el-checkbox v-model="item.checked">{{ $t(item.label) }}</el-checkbox>
              <span class="icon-size">
                 <span class="iconfont icon-tuodong" style="font-size: 12px"></span>
              </span>
            </div>
          </li>
        </transition-group>
        <div class="title-button-wrap">
          <el-button type="primary" class="title-button" :loading="isSettingButtonLoading" @click="onSaveClick">
            {{ $t('message.tableTitleCommon.saveConfiguration') }}
          </el-button>
          <el-button class="title-link" @click="onDefaultClick">
            {{ $t('message.tableTitleCommon.defaultConfiguration') }}
          </el-button>
        </div>
      </div>
    </el-popover>
    <!--    </el-drawer>-->
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import { ShowErrorMessage, ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { SEARCH_TITLE_SEARCH } from '@/store/modules/search';
import { formatDate } from '@/utils/tools/time';
import { isNullForTransferValue, shallowClones } from '@/utils/tools/utils';

export default {
  name: 'TitleSettings',
  props: {
    // /**
    //  * 显示抽屉
    //  */
    // drawerDisplay: {
    //   type: Boolean,
    //   default: false,
    // },
    /**
     * 模版
     */
    tableSet: {
      type: Array,
      default: () => [],
    },
    /**
     * 路由的名称
     */
    routerName: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  data() {
    return {
      // 弹出框开关
      drawerDisplay: false,
      // 当前选中的下标
      currentIndex: '',
      // 设置Title顺序的JSON数组
      titleSettingsList: null,
      isSettingButtonLoading: false,
      // 是否需要排序(如果是页面第一次进的话不用排序)
      isTitleSorting: false,
    };
  },
  methods: {
    handleClose() {
      this.drawerDisplay = false;
      this.$emit('onClose', false);
    },
    handleOpen() {
      this.drawerDisplay = !this.drawerDisplay;
      if (this.drawerDisplay) {
        this.tableSet.forEach((item) => {
          if (this.judgeItemDisplay(item)) {
            this.titleSettingsList.forEach(pItem => {
              if (pItem.key === item.key) {
                pItem.checked = item.isItemSettingsDisplay;
              }
            });
          }
        });
      }
    },
    dragstart(index) {
      this.currentIndex = index;
    },
    dragenter(e, index) {
      e.preventDefault();
      if (this.currentIndex !== index) {
        const source = this.titleSettingsList[this.currentIndex];
        this.titleSettingsList.splice(this.currentIndex, 1);
        this.titleSettingsList.splice(index, 0, source);
        this.currentIndex = index;
      }
    },
    dragover(e, index) {
      e.preventDefault();
    },
    /**
     * 获得存储的Key
     * @returns {string}
     */
    getSettingKey() {
      return this.routerName + '/' + this.app.userLogin.userId;
    },
    /**
     * 剔除不需要显示的条目
     * @param item
     * @returns {boolean}
     */
    judgeItemDisplay(item) {
      return item.titleBar.type !== 'checkbox' && item.titleBar.type !== 'operations' && item.titleBar.type !== 'click' &&
        isNullForTransferValue(item.key);
    },
    /**
     * 获取喜好设置
     */
    readTitleSetting() {
      const paramsList = JSON.parse(localStorage.getItem(this.getSettingKey()));
      this.isTitleSorting = !!paramsList;
      this.titleSettingsList = [];
      this.tableSet.forEach(item => {
        if (this.judgeItemDisplay(item)) {
          if (paramsList && Array.isArray(paramsList) && paramsList.length > 0) {
            // 找出相同元素并且赋值
            for (const pItem of paramsList) {
              if (pItem.key === item.key) {
                item.isItemSettingsDisplay = +pItem.checked === 1;
                item.index = +pItem.index;
                this.titleSettingsList.push({
                  index: +pItem.index,
                  key: item.key,
                  checked: item.isItemSettingsDisplay,
                  label: item.titleBar.title,
                });
              }
            }
          } else {
            item.isItemSettingsDisplay = item.isItemSettingsDisplay !== false;
            this.titleSettingsList.push({
              key: item.key,
              checked: item.isItemSettingsDisplay,
              label: item.titleBar.title,
            });
          }
        } else {
          item.isItemSettingsDisplay = true;
        }
      });
      // 找出不同元素并且赋值
      const array = [];
      this.tableSet.concat(this.titleSettingsList).forEach(item => {
        array.push(item.key);
      });
      const arr = array.filter(function(item, i, array) {
        return item && array.lastIndexOf(item) === array.indexOf(item);
      });
      if (arr && arr.length > 0) {
        for (const arrItem of arr) {
          if (arrItem) {
            this.tableSet.forEach((tableItem, index) => {
              if (tableItem.key === arrItem && this.judgeItemDisplay(tableItem)) {
                tableItem.isItemSettingsDisplay = tableItem.isItemSettingsDisplay !== false;
                this.titleSettingsList.push({
                  key: tableItem.key,
                  checked: tableItem.isItemSettingsDisplay,
                  label: tableItem.titleBar.title,
                  index: this.tableSet.length + index,
                });
              }
            });
          } else {
            this.titleSettingsList.splice(this.titleSettingsList.findIndex(e => arrItem === e.key), 1);
          }
        }
      }
      if (this.isTitleSorting) {
        // 排序
        this.titleSettingsList = [...this.titleSettingsList].sort((a, b) => {
          return isNullForTransferValue(String(a.index)) && isNullForTransferValue(String(b.index)) ? a.index - b.index : 1;
        });
      }
    },
    saveTitleSetting(paramsList) {
      this.isSettingButtonLoading = true;
      const count = setTimeout(() => {
        this.isSettingButtonLoading = false;
        clearTimeout(count);
      }, 1000);
      try {
        this.tableSet.forEach(item => {
          if (this.judgeItemDisplay(item)) {
            paramsList.forEach((pItem, index) => {
              if (pItem.key === item.key) {
                item.isItemSettingsDisplay = pItem.checked;
                pItem.checked = +item.isItemSettingsDisplay ? '1' : '0';
                pItem.index = index;
              }
            });
          }
        });
        // 去重
        for (let i = 0, len = paramsList.length; i < len; i++) {
          for (let j = i + 1, len = paramsList.length; j < len; j++) {
            if (paramsList[i].key === paramsList[j].key) {
              paramsList.splice(j, 1);
              // eslint-disable-next-line no-plusplus
              j--;
              // eslint-disable-next-line no-plusplus
              len--;
            }
          }
        }
        localStorage.setItem(this.getSettingKey(), JSON.stringify(paramsList));
        // 最后刷新下
        this.readTitleSetting();
        // this.sendSettingsForDisplay(paramsList);
        this.$emit('onSettingSaveClick');
        ShowSuccessMessage(this.$t('message.settingsSuccessfulTip'));
      } catch (e) {
        ShowErrorMessage(this.$t('message.settingsFailedTip'));
      } finally {
      }
    },
    onSaveClick() {
      try {
        const paramsList = shallowClones(null, this.titleSettingsList);
        // 至少选择一项吧
        if (paramsList.filter(item => item.checked).length <= 2) {
          ShowWarningMessage(this.$t('message.tableTitleCommon.selectOneTitle'));
          return;
        }
        this.saveTitleSetting(paramsList);
        this.handleClose();
      } catch (e) {
        ShowErrorMessage(this.$t('message.settingsFailedTip'));
      }
    },
    onDefaultClick() {
      localStorage.setItem(this.getSettingKey(), null);
      this.readTitleSetting();
      // this.sendSettingsForDisplay();
      this.handleClose();
      this.$emit('onRestoreDefaultClick');
    },
    /**
     *  发送给搜索组件做接下来的操作
     * @param paramsList
     */
    sendSettingsForDisplay(paramsList) {
      if (paramsList) {
        const array = paramsList.filter(item => +item.checked === 0).map(item => ({
          titleSearchKey: item.key,
          queryDisplayValue: '2',
        }));
        if (array.length > 0) {
          this.$store.commit(SEARCH_TITLE_SEARCH, {
            name: this.routerName,
            value: array,
            time: formatDate(new Date()),
          });
        }
      }
    },
  },
  mounted() {
    this.readTitleSetting();
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';
.el-popover__title {
  margin: 15px 8px;
  font-size: 16px;
  font-weight: 800;
  color: $color-primary;
}

#title-settings {
  max-height: 800px;
  overflow: scroll;

  .title-wrap {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
  }

  .list {
    list-style: none;
    padding: 0;
    margin: 0;

    .drag-move {
      transition: transform .3s;
    }

    .list-item {
      cursor: move;
      width: 280px;
      border-radius: 4px;
      color: #FFFFFF;
      margin-bottom: 6px;
      height: 100%;
      line-height: 100%;
      padding: 0 8px;
      margin-right: 0px;

      &:active, &:hover {
        background-color: $color-default;
      }

      &:active {
        font-size: 0;
      }
    }

    .icon-size {
      height: 100%;
      color: $color-text-primary;
    }

    .el-checkbox {
      color: $color-text-primary;
    }
  }

  .title-button-wrap {
    margin: 15px 8px 0;

    .title-button {
      font-size: 14px;
      width: 100%;
      margin-bottom: 10px;
      background-color: $color-text-default-button;
    }

    .title-link {
      width: 100%;
      font-size: 14px;
      color: $color-primary;
      margin-left: 0px;
      background-color: transparent;
      border: 0px;

      &:active {
        opacity: .7;
      }
    }
  }
}
</style>
